import rgbHex from "rgb-hex";

const table_border_styles = [
  { title: "Solid", value: "solid" },
  { title: "Dotted", value: "dotted" },
  { title: "Dashed", value: "dashed" },
  { title: "Double", value: "double" },
  { title: "Groove", value: "groove" },
  { title: "Ridge", value: "ridge" },
  { title: "Inset", value: "inset" },
  { title: "Outset", value: "outset" },
  { title: "None", value: "none" },
  { title: "Hidden", value: "hidden" },
]
const table_default_styles = {
  "border-color": "black",
  "border-style": "solid",
  "border-width": ".5px",
  "border-collapse": "collapse",
  "border-spacing": "0",
  "background-color": "#FFFFFF",
};
const table_default_attributes = {
  cellPadding: "10px",
  cellBorder: "1px solid black",
  border: ".5px",
  borderColor: "black",
  borderStyle: "solid",
}
const style_formats = [
  { title: "None", format: "none" },
  { title: "Paragraph", format: "p" },
  { title: "Header 1", format: "h1" },
  { title: "Header 2", format: "h2" },
  { title: "Header 3", format: "h3" },
  { title: "Header 4", format: "h4" },
  { title: "Paragraph *", format: "p_all" },
  { title: "Header 1 *", format: "h1_all" },
  { title: "Header 2 *", format: "h2_all" },
  { title: "Header 3 *", format: "h3_all" },
  { title: "Header 4 *", format: "h4_all" },
];
const format_types = style_formats.map((format) => (format.format))
const tinymce_events = {
  mceTableInsertRowAfter: 'mceTableInsertRowAfter',
  mceTableInsertRowBefore: 'mceTableInsertRowBefore',
  mceTableInsertColAfter: 'mceTableInsertColAfter',
  mceTableInsertColBefore: 'mceTableInsertColBefore',
  mceTableDeleteRow: 'mceTableDeleteRow',
  mceTableDeleteCol: 'mceTableDeleteCol',
  mceTableMergeCells: 'mceTableMergeCells',
  mceTableSplitCells: 'mceTableSplitCells',
  mceTableSelectRow: 'mceTableSelectRow',
  mceTableSelectCell: 'mceTableSelectCell',
  mceTableSelectCol: 'mceTableSelectCol',
}
const generateContentStyle = (tableWrapperId, tableHeaderSticky, tableColumnSticky) => {
  let styles = '';

  // Sticky header styles
  if (tableHeaderSticky) {
    styles += `
      #${tableWrapperId} thead tr td {
        position: sticky;
        top: 0;
      }
    `;
  }

  // Sticky first column styles
  if (tableColumnSticky) {
    styles += `
      #${tableWrapperId} tr td:first-child {
        position: sticky;
        left: 0;
      }
      #${tableWrapperId} tbody tr td:first-child {
        background-color: rgb(255, 255, 255);
      }
    `;
  }

  return styles;
};

export default {
  table_border_styles,
  table_default_styles,
  table_default_attributes,
  style_formats,
  tinymce_events,
  format_types,
  generateContentStyle,
}

export const getAllResizerContainers = () =>
  document.querySelectorAll('[id^="resizer-container_"]');
export const getResizerContainer = (parentId) =>
  document.querySelector(`[data-editor-id="${parentId}"]`);
export const getParentContainer = (parentId) => {
  try {
    return document.querySelector(`#${parentId}`);
  } catch (error) {
    return null;
  }
};
export const addAsteriskToStyleFormat = (lastSelectedNode, command) => {
  // Check if lastSelectedNode is valid and not empty
  if (
    !lastSelectedNode ||
    !(lastSelectedNode instanceof Node) ||
    (lastSelectedNode instanceof Element && lastSelectedNode.innerHTML.trim() === "") ||
    (lastSelectedNode instanceof Element && lastSelectedNode.innerHTML.trim() === "\uFEFF") ||
    (lastSelectedNode instanceof Element && lastSelectedNode.innerHTML.trim() === "&nbsp;")
  ) return;
  const parentElement = lastSelectedNode.closest('h1, h2, h3, h4, p');
  if (!parentElement) return;
  let mceStyles = parentElement.getAttribute('data-mce-style') || '';

  if (command === 'FontSize') {
    mceStyles = mceStyles.replace(/font-size:[^;]*;?/g, '').trim();

    if (mceStyles) {
      parentElement.setAttribute('data-mce-style', mceStyles);
    } else {
      parentElement.removeAttribute('data-mce-style');
    }

    parentElement.style.fontSize = '';
  }

  if (
    command === 'FontName'
  ) {
    const fontSizeMatch = mceStyles.match(/font-size:([^;]*);?/);
    const fontSize = fontSizeMatch ? fontSizeMatch[1].trim() : parentElement.style.fontSize || 'not set';
    mceStyles = mceStyles.replace(/font-size:[^;]*;?/g, '').trim();

    if (mceStyles) {
      parentElement.setAttribute('data-mce-style', mceStyles);
    } else {
      parentElement.removeAttribute('data-mce-style');
    }

    setTimeout(() => {
      lastSelectedNode.style.fontSize = fontSize;
      parentElement.style.fontSize = '';
    }, 0);
  }
};

export const distributeColumnsIcon = `
<svg width="18" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170.41 164.11">
  <defs>
    <style>
      .cls-1 { fill: none; stroke: #222f3e; stroke-width: 10px; }
      .cls-2 { fill: #232f3e; stroke: #222f3e; stroke-width: 10px; }
    </style>
  </defs>
  <rect class="cls-1" x="8" y="97" width="56.9" height="56.9" rx="5.97" ry="5.97"/><rect class="cls-1" x="103.51" y="97.21" width="56.9" height="56.9" rx="5.97" ry="5.97"/><path class="cls-2" d="M154.44,89.21h-44.96c-7.7,0-13.97,6.27-13.97,13.97v44.96c0,7.7,6.27,13.97,13.97,13.97h44.96c7.7,0,13.97-6.27,13.97-13.97v-44.96c0-7.7-6.27-13.97-13.97-13.97ZM160.41,148.14c0,3.29-2.68,5.97-5.97,5.97h-44.96c-3.29,0-5.97-2.68-5.97-5.97v-44.96c0-3.29,2.68-5.97,5.97-5.97h44.96c3.29,0,5.97,2.68,5.97,5.97v44.96Z"/><path class="cls-2" d="M58.93,89H13.97c-7.7,0-13.97,6.27-13.97,13.97v44.96c0,7.7,6.27,13.97,13.97,13.97h44.96c7.7,0,13.97-6.27,13.97-13.97v-44.96c0-7.7-6.27-13.97-13.97-13.97ZM64.9,147.93c0,3.29-2.68,5.97-5.97,5.97H13.97c-3.29,0-5.97-2.68-5.97-5.97v-44.96c0-3.29,2.68-5.97,5.97-5.97h44.96c3.29,0,5.97,2.68,5.97,5.97v44.96Z"/><path class="cls-2" d="M4.59,70h.03c2.19,0,3.98-1.77,4-3.97l.5-62c.02-2.21-1.76-4.01-3.97-4.03h-.03C2.93,0,1.14,1.77,1.12,3.97l-.5,62c-.02,2.21,1.76,4.01,3.97,4.03Z"/><path class="cls-2" d="M163.59,70h.03c2.19,0,3.98-1.77,4-3.97l.5-62c.02-2.21-1.76-4.01-3.97-4.03h-.03c-2.19,0-3.98,1.77-4,3.97l-.5,62c-.02,2.21,1.76,4.01,3.97,4.03Z"/><path class="cls-2" d="M42.14,60.08c.79.92,1.91,1.39,3.03,1.39.92,0,1.85-.32,2.61-.97,1.68-1.44,1.87-3.97.42-5.64l-13.45-15.65h97.51l-13.45,15.65c-1.44,1.67-1.25,4.2.42,5.64.76.65,1.68.97,2.61.97,1.12,0,2.24-.47,3.04-1.39l19.17-22.29c1.29-1.5,1.29-3.73,0-5.23l-19.23-22.22c-1.45-1.67-3.97-1.85-5.64-.41-1.67,1.45-1.85,3.97-.41,5.64l13.54,15.64H34.72l13.54-15.64c1.45-1.67,1.26-4.2-.41-5.64-1.67-1.45-4.2-1.26-5.64.41l-19.23,22.22c-1.3,1.5-1.3,3.72,0,5.23l19.17,22.29Z"/>
</svg>
`;

export const distributeRowsIcon = `
<svg width="22" height="22" viewBox="-4 0 232.35 168.41" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <style>
      .cls-1 { fill: none; stroke: #222f3e; stroke-width: 10px; }
      .cls-2 { fill: #232f3e; stroke: #222f3e; stroke-width: 10px; }
    </style>
  </defs>
  <rect class="cls-1" x="8.21" y="8" width="56.9" height="56.9" rx="5.97" ry="5.97"/>
  <rect class="cls-1" x="8" y="103.51" width="56.9" height="56.91" rx="5.97" ry="5.97"/>
  <path class="cls-2" d="M58.93,95.51H13.97c-7.7,0-13.97,6.27-13.97,13.97v44.96c0,7.7,6.27,13.97,13.97,13.97h44.96c7.7,0,13.97-6.27,13.97-13.97v-44.96c0-7.7-6.27-13.97-13.97-13.97ZM64.9,154.44c0,3.29-2.68,5.97-5.97,5.97H13.97c-3.29,0-5.97-2.68-5.97-5.97v-44.96c0-3.29,2.68-5.97,5.97-5.97h44.96c3.29,0,5.97,2.68,5.97,5.97v44.96Z"/>
  <path class="cls-2" d="M59.14,0H14.18C6.48,0,.21,6.27.21,13.97v44.96c0,7.7,6.27,13.97,13.97,13.97h44.96c7.7,0,13.97-6.27,13.97-13.97V13.97c0-7.7-6.27-13.97-13.97-13.97ZM65.11,58.93c0,3.29-2.68,5.97-5.97,5.97H14.18c-3.29,0-5.97-2.68-5.97-5.97V13.97c0-3.29,2.68-5.97,5.97-5.97h44.96c3.29,0,5.97,2.68,5.97,5.97v44.96Z"/>
  <path class="cls-2" d="M96.08,8.62l62,.5h.03c2.19,0,3.98-1.77,4-3.97.02-2.21-1.76-4.01-3.97-4.03l-62-.5h-.03c-2.19,0-3.98,1.77-4,3.97-.02,2.21,1.76,4.01,3.97,4.03Z"/>
  <path class="cls-2" d="M158.15,160.12l-62-.5h-.03c-2.19,0-3.98,1.77-4,3.97-.02,2.21,1.76,4.01,3.97,4.03l62,.5h.03c2.19,0,3.98-1.77,4-3.97.02-2.21-1.76-4.01-3.97-4.03Z"/>
  <path class="cls-2" d="M146.54,48.26c.76.65,1.69.98,2.62.98,1.12,0,2.24-.47,3.03-1.38,1.45-1.67,1.26-4.2-.41-5.64l-22.22-19.23c-1.5-1.3-3.72-1.3-5.23,0l-22.29,19.17c-1.67,1.44-1.87,3.97-.42,5.64,1.44,1.67,3.97,1.87,5.64.42l15.65-13.45v97.51l-15.65-13.45c-1.68-1.44-4.2-1.25-5.64.43-1.44,1.68-1.25,4.2.42,5.64l22.29,19.17c.75.65,1.68.97,2.61.97s1.87-.33,2.62-.98l22.22-19.23c1.67-1.45,1.85-3.97.41-5.64-1.45-1.67-3.97-1.85-5.64-.41l-15.64,13.54V34.72l15.64,13.54Z"/>
</svg>
`;


export const getDesktopTableStyles = (props) => {
  const styles = {
    paddingTop:
      props.element.desktopStyle.marginTop +
      (props.tableDesktopUnit
        ? props.tableDesktopUnit
        : "px"),
    paddingBottom:
      props.element.desktopStyle.marginBottom +
      (props.tableDesktopUnit
        ? props.tableDesktopUnit
        : "px"),
    paddingLeft:
      props.element.desktopStyle.paddingLeft +
      (props.tableDesktopUnit
        ? props.tableDesktopUnit
        : "px"),
    paddingRight:
      props.element.desktopStyle.paddingRight +
      (props.tableDesktopUnit
        ? props.tableDesktopUnit
        : "px"),
    width: "100%",
    height:
      props.element.desktopStyle.fullHeight === false
        ? props.element.desktopStyle.height + "px"
        : "fit-content",
    //flag
    overflowY:
      !!props.element.desktopStyle.fullHeight
        ? "hidden"
        : "auto",
    minHeight: "50px",
  };
  return styles;
}

export const getMobileTableStyles = (props) => {
  const styles = {
    paddingTop:
      props.element.mobileStyle.marginTop +
      (props.tableMobileUnit
        ? props.tableMobileUnit
        : "px"),
    paddingBottom:
      props.element.mobileStyle.marginBottom +
      (props.tableMobileUnit
        ? props.tableMobileUnit
        : "px"),
    paddingLeft:
      props.element.mobileStyle.paddingLeft +
      (props.tableMobileUnit
        ? props.tableMobileUnit
        : "px"),
    paddingRight:
      props.element.mobileStyle.paddingRight +
      (props.tableMobileUnit
        ? props.tableMobileUnit
        : "px"),
    width: "100%",
    minHeight: "50px",
    overflowY:
      !!props.element.mobileStyle.fullHeight
        ? "hidden"
        : "auto",
    height:
      !!props.element.mobileStyle.fullHeight
        ? "fit-content"
        : props.element.mobileStyle.height + "px"
  }
  return styles;
}
export const getLineHeight = (content) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');

  // Find all elements with a style attribute
  const elementsWithStyle = doc.querySelectorAll('[style]');

  let lineHeight = null;

  // Iterate through elements to find line-height
  elementsWithStyle.forEach(element => {
    const style = element.getAttribute('style');
    const lineHeightMatch = style.match(/line-height\s*:\s*([^;]+)/i);
    if (lineHeightMatch) {
      lineHeight = lineHeightMatch[1].trim();
    }
  });

  return lineHeight;
}

export const textToolbarEventValues = [
  'bold',
  'italic',
  'underline',
];
export const textToolbarEvent = [
  'mceApplyTextcolor',
  'FontName',
  'FontSize',
]
export const WHITE_COLOR = '#FFFFFF';
export const getBgColorTableAttribute = (element) => {
  const styles = element.getAttribute('style') || '';
  const match = styles.match(/background-color:\s*([^;]+)/);
  const backgroundColor = match ? match[1].trim() : null;
  return backgroundColor;
}
export const getBorderColorTableAttribute = (element) => {
  const styles = element.getAttribute('style') || '';
  const match = styles.match(/border-color:\s*([^;]+)/);
  const borderColor = match ? match[1].trim() : null;
  return borderColor;
};
export const getTableStyles = (table) => {
  if (!table) return {};
  const computedStyles = window.getComputedStyle(table);
  return {
    height: computedStyles.getPropertyValue('height'),
    width: computedStyles.getPropertyValue('width'),
    backgroundColor: computedStyles.getPropertyValue('background-color'),
    border: computedStyles.getPropertyValue('border'),
  };
};
export const detectStyleChanges = (previousStyles, currentStyles) => {
  const changes = {};
  for (const key in currentStyles) {
    if (currentStyles[key] !== previousStyles[key]) {
      changes[key] = {
        oldValue: previousStyles[key],
        newValue: currentStyles[key],
      };
    }
  }
  return changes;
};
export const getElementStyles = (element, isCell = false) => {
  if (!element) return {};
  const computedStyles = window.getComputedStyle(element);
  const hasBackgroundStyle = element.style.backgroundColor;
  
  return {
    height: computedStyles.getPropertyValue('height'),
    width: isCell ? element.style.width : computedStyles.getPropertyValue('width'),
    backgroundColor: computedStyles.getPropertyValue('background-color'),
    border: computedStyles.getPropertyValue('border'),
    backgroundColorStyle: hasBackgroundStyle,
  };
};
export const getListFormatStyles = (format) => {
  const styles = {
    color: format?.styles?.color,
    fontFamily: format?.styles?.fontFamily,
    fontSize: format?.styles?.fontSize,
    lineHeight: format?.styles?.lineHeight,
  }
  const cssText = `
                    font-family: ${styles.fontFamily};
                    font-size:   ${styles.fontSize};
                    color:       ${styles.color};
                    line-height: ${styles.lineHeight};
                  `.trim().replace(/\s+/g, ' ');
  return cssText;
}

/**
* Converts emojis to HTML numeric character references (NCR)
* This ensures emojis are properly encoded for database storage
* and prevents parsing issues with hexadecimal characters (b,c,d,e,f)
* 
* Version 2: Fixed issues with missing semicolons and improved emoji detection
*/
export const emojiToUnicode = (text) => {
  // Use a more comprehensive regex that matches all emoji characters
  // including multi-codepoint emojis (e.g., skin tones, flags, ZWJ sequences)
  return text.replace(
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}\u{1F018}-\u{1F270}\u{238C}-\u{2454}\u{20D0}-\u{20FF}\u{FE00}-\u{FE0F}\u{1F004}-\u{1F0CF}\u{1F170}-\u{1F251}]/gu,
    (match) => {
      // Get all code points in case of multi-codepoint emojis
      let result = '';
      for (let i = 0; i < match.length; i++) {
        const codePoint = match.codePointAt(i);
        if (codePoint > 0xFFFF) {
          // Skip the next character for surrogate pairs
          i++;
        }
        // Important: Add semicolon to properly terminate the HTML entity
        // Without it, following hex characters (b,c,d,e,f) are interpreted as part of the entity
        result += '&#x' + codePoint.toString(16).toUpperCase() + ';';
      }
      return result;
    }
  );
}

export const getCurrentStyles = (editor) => {
  const formats = editor.formatter.get();
  const appliedFormats = [];

  Object.keys(formats).forEach(formatName => {
    if (editor.formatter.match(formatName)) {
      appliedFormats.push(formatName);
    }
  });

  return appliedFormats;
};

export const selectionIsAList = (content) => {
  if (!content) return false;
  const trimmedHtml = content.trim();
  const listRegex = /^(?:<ol>|<ul>)([\s\S]*?)(?:<\/ol>|<\/ul>)$/i;
  return listRegex.test(trimmedHtml);
}
export const contentTags = (htmlString) => {
  const validElements = ['h1', 'h2', 'h3', 'h4', 'p'];
  const foundTags = new Set();

  // Create a regular expression to match opening tags of valid elements
  const tagRegex = /<(h1|h2|h3|h4|p)\b[^>]*>/gi;

  // Find all matches in the HTML string
  const matches = htmlString.match(tagRegex) || [];

  // Extract tag names from matches and add to Set
  matches.forEach(match => {
    const tagName = match.match(/(h1|h2|h3|h4|p)/i)[0].toLowerCase();
    if (validElements.includes(tagName)) {
      foundTags.add(tagName);
    }
  });

  // Convert Set to Array and return
  return Array.from(foundTags);
}

export const captureTableAlignment = (content) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;
  const table = tempDiv.querySelector('table');

  return {
    marginLeft: table?.style.marginLeft || 'auto',
    marginRight: table?.style.marginRight || 'auto'
  };
};

export const restoreTableMargins = (table) => {
  if (!table || !originalTableMarginsRef.current) return;

  const { marginLeft, marginRight } = originalTableMarginsRef.current;

  if (marginLeft) {
    table.style.marginLeft = marginLeft;
  }
  if (marginRight) {
    table.style.marginRight = marginRight;
  }
};

export const applyTableAlignment = (content, justifyContent) => {
  if (!content || !justifyContent) return content;

  let modifiedContent = content;

  if (justifyContent === "center") {
    modifiedContent = modifiedContent.replace(/(<table[^>]*style="[^"]*)/gi, '$1 margin-left: auto; margin-right: auto;');
  } else if (justifyContent === "flex-start") {
    modifiedContent = modifiedContent.replace(/(<table[^>]*style="[^"]*)/gi, '$1 margin-left: 0; margin-right: auto;');
  } else if (justifyContent === "flex-end") {
    modifiedContent = modifiedContent.replace(/(<table[^>]*style="[^"]*)/gi, '$1 margin-left: auto; margin-right: 0;');
  }

  return modifiedContent;
};

export const justifyContentSelectValue = (props) => {
  const isMobile = props.mobileView;
  const isMirrored = props.isMirrored;

  if (isMobile) {
    const property = isMirrored ? "desktopStyle" : "mobileStyle";
    return props.element[property].justifyContent
      ? props.element[property].justifyContent
      : "flex-start"
  }

  return props.element.desktopStyle &&
    props.element.desktopStyle.justifyContent
    ? props.element.desktopStyle.justifyContent
    : "flex-start"
}

export const getJustifyContentValue = (content) => {
  if (!content) return 'flex-start';

  // Parse the HTML content to find the table element
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  const tableElement = doc.querySelector('table');

  if (!tableElement) return 'flex-start';

  const tableStyle = tableElement.getAttribute('style') || '';

  // Extract margin-left and margin-right values
  const marginLeftRegex = /margin-left:\s*([^;]+);?/;
  const marginRightRegex = /margin-right:\s*([^;]+);?/;

  const marginLeftMatch = tableStyle.match(marginLeftRegex);
  const marginRightMatch = tableStyle.match(marginRightRegex);

  const marginLeft = marginLeftMatch ? marginLeftMatch[1].trim() : 'auto';
  const marginRight = marginRightMatch ? marginRightMatch[1].trim() : 'auto';

  // Determine justifyContent based on margins
  if (marginLeft === 'auto' && marginRight === 'auto') {
    return 'center';
  } else if (marginLeft === '0' && marginRight === 'auto') {
    return 'flex-start';
  } else if (marginLeft === 'auto' && marginRight === '0') {
    return 'flex-end';
  } else {
    return 'flex-start'; // default value
  }
};

export const processTableMargins = (desktopContent) => {
  // Parse the HTML content to find the table element
  const parser = new DOMParser();
  const doc = parser.parseFromString(desktopContent, 'text/html');
  const tableElement = doc.querySelector('table');

  if (!tableElement) {
    return {
      modifiedContent: desktopContent,
      justifyContent: 'center'
    };
  }

  // Get table style and determine justifyContent
  let marginLeft = 'auto';
  let marginRight = 'auto';
  let justifyContent = 'center';
  let tableStyle = tableElement.getAttribute('style') || '';

  const marginLeftRegex = /margin-left:\s*([^;]+);/;
  const marginRightRegex = /margin-right:\s*([^;]+);/;
  const marginLeftValue = tableStyle.match(marginLeftRegex);
  const marginRightValue = tableStyle.match(marginRightRegex);

  if (marginLeftValue) {
    marginLeft = marginLeftValue[1].trim();
  }
  if (marginRightValue) {
    marginRight = marginRightValue[1].trim();
  }

  // Determine justifyContent based on margins
  if (marginLeft === 'auto' && marginRight === 'auto') {
    justifyContent = 'center';
  } else if (marginLeft === '0' && marginRight === 'auto') {
    justifyContent = 'flex-start';
  } else if (marginLeft === 'auto' && marginRight === '0') {
    justifyContent = 'flex-end';
  } else {
    justifyContent = 'center'; // default
  }

  // Remove margin-left and margin-right from table style
  tableStyle = tableStyle.replace(marginLeftRegex, '').replace(marginRightRegex, '');
  tableElement.setAttribute('style', tableStyle);
  tableElement.setAttribute('data-mce-style', tableStyle);

  // Get the modified content as string
  const modifiedContent = doc.documentElement.outerHTML;

  return {
    modifiedContent: tableElement.outerHTML,
    justifyContent
  };
};

export const toHexColor = color => {
  if (typeof color === 'string') {
    if (color.startsWith('#')) return color.toLowerCase();

    // Case: rgb(R, G, B)
    const rgbMatch = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (rgbMatch) return '#' + rgbHex(+rgbMatch[1], +rgbMatch[2], +rgbMatch[3]).toLowerCase();

    // Case: rgba(R, G, B, A)
    const rgbaMatch = color.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*[\d.]+\)$/);
    if (rgbaMatch) return '#' + rgbHex(+rgbaMatch[1], +rgbaMatch[2], +rgbaMatch[3]).toLowerCase();

    return color;
  }
  if (color && typeof color === 'object' && 'r' in color) {
    return '#' + rgbHex(color.r, color.g, color.b).toLowerCase();
  }
  return null;
};

/**
 * Processes layout elements to convert emojis to Unicode in TEXT and TABLE elements
 * Recursively processes nested Row/Column structures
 */
export const processLayoutElementForEmoji = (element) => {
  if (!element || typeof element !== 'object') return;
  
  // Process TEXT elements
  if (element.data === 'TEXT' && element.text) {
    element.text = emojiToUnicode(element.text);
  }
  
  // Process TABLE elements
  if (element.data === 'TABLE') {
    if (element.desktopStyle && element.desktopStyle.content) {
      element.desktopStyle.content = emojiToUnicode(element.desktopStyle.content);
    }
    if (element.mobileStyle && element.mobileStyle.content) {
      element.mobileStyle.content = emojiToUnicode(element.mobileStyle.content);
    }
  }
  
  // Process nested Row/Column structures
  if (element.data === 'Row' && element.columns) {
    Object.keys(element.columns).forEach((colKey) => {
      if (Array.isArray(element.columns[colKey])) {
        element.columns[colKey].forEach((colItem) => {
          processLayoutElementForEmoji(colItem);
        });
      }
    });
  }
};